import { isEmpty } from "lodash";
import moment from "moment";
import Message from "pages/forms/_components/_fields/_scheduler/Message";
import { transactionStatus } from "pages/transactions/constants";
import Avatar from "pages/_components/Avatar";
import Button from "pages/_components/Button";
import CustomData from "pages/_components/CustomData/CustomData";
import CustomText from "pages/_components/CustomText/CustomText";
import FormattedAmount from "pages/_components/FormattedAmount";
import Image from "pages/_components/Image";
import { TransactionSign } from "pages/_components/TransactionCard";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import { bool, func, shape, string } from "prop-types";
import React, { useContext, useState } from "react";
import * as i18n from "util/i18n";
import * as schedulerUtils from "util/scheduler";

const BackofficeTransactionPage = (props) => {
    const { setShowMoreData, showMoreData, isDesktop } = props;
    const { transaction = {} } = useContext(TransactionContext);
    const { data = {}, creationDateTime = moment(), idTransactionStatus = "", programed = false } = transaction;
    const isFinished = idTransactionStatus === transactionStatus.FINISHED;
    const isPending = idTransactionStatus === transactionStatus.PENDING;

    const [buttonLabel, setButtonLabel] = useState("echecks.seeMore.button");

    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
        if (!showMoreData) {
            setButtonLabel("echecks.seeLess.button");
        } else {
            setButtonLabel("echecks.seeMore.button");
        }
    };
    const {
        debitAccountLabel = props.debitAccountLabel,
        ownerName = props.ownerName,
        beneficiary = props.beneficiary,
        beneficiaryAccountLabel = props.beneficiaryAccountLabel,
        creditCbu = props.creditCbu,
        transferKind = props.transferKind,
        amount = props.amount,
        reasonCode = props.reasonCode,
        reference = props.reference,
        reason = props.reason,
        sendEmail = props.sendEmail,
        email = props.email,
        emailText = props.emailText,
        scheduler = props.scheduler,
    } = data;
    const isProgramed = programed || !isEmpty(scheduler);

    const showEmailInfo = sendEmail;

    const ProgrammedBody = () => {
        if (!isProgramed) {
            return null;
        }

        if (scheduler.program?.isCustom) {
            return (
                <>
                    <>
                        <div className="ticket__divider inside-ticket__body">
                            <div className="ticket__notch ticket__notch--left"> </div>
                            <div className="ticket__notch ticket__notch--right"> </div>
                        </div>
                        <h2>{i18n.get("", "Datos de programación")}</h2>
                    </>
                    <CustomData
                        titleText="scheduler.custom"
                        titleTextType="I18N"
                        valueText={<Message value={scheduler || { valueDate: "" }} />}
                    />
                    <div className="ticket__divider inside-ticket__body">
                        <div className="ticket__notch ticket__notch--left"> </div>
                        <div className="ticket__notch ticket__notch--right"> </div>
                    </div>
                </>
            );
        }

        if (scheduler.selectedOption === schedulerUtils.ONCE) {
            return (
                <>
                    <div className="ticket__divider inside-ticket__body">
                        <div className="ticket__notch ticket__notch--left"> </div>
                        <div className="ticket__notch ticket__notch--right"> </div>
                    </div>
                    <h2>{i18n.get("", "Datos de programación")}</h2>
                    <CustomData
                        titleText="transfer.datetime"
                        titleTextType="I18N"
                        valueText={
                            isFinished || isPending ? (
                                <CustomText textType="DATE" text={scheduler?.program?.startsOn || creationDateTime} />
                            ) : (
                                <b>
                                    <Message value={scheduler || { valueDate: "" }} />
                                </b>
                            )
                        }
                    />
                    <CustomData
                        titleText="scheduler.frequency"
                        titleTextType="I18N"
                        valueText="scheduler.future"
                        valueTextType="I18N"
                    />
                </>
            );
        }

        const lapseEndText = (lapse, times = 0, date) => {
            switch (lapse) {
                case "UNLIMITED":
                    return i18n.get("scheduler.never");
                case "UNTIL":
                    return moment(date).format("ll");
                case "UP_TO":
                    return `${i18n.get("scheduler.after")} ${times} ${i18n.get("scheduler.times").toLowerCase()}`;
                default:
                    return "";
            }
        };

        return (
            <>
                <div className="ticket__divider inside-ticket__body">
                    <div className="ticket__notch ticket__notch--left"> </div>
                    <div className="ticket__notch ticket__notch--right"> </div>
                </div>
                <h2>{i18n.get("", "Datos de programación")}</h2>
                <CustomData
                    titleText="transfer.datetime"
                    titleTextType="I18N"
                    valueText={scheduler?.program?.startsOn || creationDateTime}
                    valueTextType="DATE"
                />
                <CustomData
                    titleText="scheduler.frequency"
                    titleTextType="I18N"
                    valueText={`scheduler.${scheduler?.program?.frequency?.toLowerCase()}`}
                    valueTextType="I18N"
                />
                <CustomData
                    titleText="scheduler.enddate"
                    titleTextType="I18N"
                    valueText={lapseEndText(
                        scheduler?.program?.lapse,
                        scheduler?.program?.number,
                        scheduler?.program?.date,
                    )}
                />
            </>
        );
    };

    if (isFinished || isPending) {
        return (
            <div className="ticket__body newpayment">
                <div className="ticket-header-info ">
                    <div className="beneficiary">
                        <div className="avatar-name">
                            <Avatar
                                user={{
                                    userFullName: beneficiary?.recipientName || "",
                                    defaultAvatarId: 0,
                                    email: beneficiary?.emailRecipient,
                                }}
                            />
                        </div>
                        <div className="user-info align-items-center">
                            <div className="small">{i18n.get("echecks.beneficiary")}</div>
                            <div className="large">{`${beneficiary?.recipientName}`}</div>
                            <div className="small">{`${beneficiary?.recipientDocumentType} ${beneficiary?.recipientDocumentNumber}`}</div>
                        </div>
                    </div>
                    <div>
                        {isProgramed ? (
                            <CustomData
                                dataClass="amount tag tag-success"
                                titleClass="text-right"
                                titleText="echecks.emit.amountField.label"
                                titleTextType="I18N"
                                valueText={<FormattedAmount currency={amount.currency} quantity={amount.quantity} />}
                            />
                        ) : (
                            <CustomData
                                dataClass={`amount tag tag-${isPending ? "warning" : "echeq-character"}`}
                                titleClass="text-right"
                                titleText="echecks.emit.amountField.label"
                                titleTextType="I18N"
                                valueText={<FormattedAmount currency={amount.currency} quantity={amount.quantity} />}
                            />
                        )}
                    </div>
                </div>
                <div className="view-more-data-button" id="element-to-ignore">
                    <div className="ticket__divider inside-ticket__body">
                        <div className="ticket__notch ticket__notch--left"> </div>
                        <div className="ticket__notch ticket__notch--right"> </div>
                    </div>
                    <Button
                        aria-expanded={showMoreData ? "true" : "false"}
                        className="more-button"
                        label={buttonLabel}
                        bsStyle="link"
                        onClick={handleSeeMoreData}
                        image={showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"}
                    />
                </div>
                <div className={`view-more-data ${showMoreData ? "expand " : "collapse"}`}>
                    <div className="emissor-beneficiary">
                        <div className="emissor-data">
                            <h2>{i18n.get("echecks.emissor", "Emisor")}</h2>

                            <CustomData
                                titleText="transfer.debitAccount.label"
                                titleTextType="I18N"
                                valueText={debitAccountLabel}
                            />
                            <CustomData titleText="transfer.sender.label" titleTextType="I18N" valueText={ownerName} />
                            <br />
                        </div>
                        <div className="transaction-arrow">
                            <Image src="images/figma/icon/arrow-right.svg" className="icon-large" />
                        </div>
                        <div className="benefitiary-data">
                            <h2 className="">{i18n.get("echecks.beneficiary")}</h2>

                            <CustomData
                                titleText="transfer.creditAccount.label"
                                titleTextType="I18N"
                                valueText={beneficiaryAccountLabel}
                            />
                            <CustomData
                                titleText="transfer.CBU/CVU/Alias"
                                titleTextType="I18N"
                                valueText={beneficiary?.cbu}
                            />

                            <CustomData
                                titleText="transfer.bank.label"
                                titleTextType="I18N"
                                valueText={beneficiary?.localBank}
                            />
                        </div>
                    </div>
                    <div className="ticket__divider divider_1 inside-ticket__body">
                        <div className="ticket__notch ticket__notch--left"> </div>
                        <div className="ticket__notch ticket__notch--right"> </div>
                    </div>
                    <div className="aditional-data">
                        <h2>{i18n.get("", "Datos adicionales")}</h2>
                        <CustomData
                            titleText="transfer.transferKind.label"
                            titleTextType="I18N"
                            valueTextType="I18N"
                            valueText={`transfer.types.${transferKind}`}
                        />
                        <CustomData
                            titleText="transfer.concept.label"
                            titleTextType="I18N"
                            valueTextType="I18N"
                            valueText={`transfer.reasons.${reasonCode}`}
                        />
                        <CustomData
                            titleText="transfer.coelsa.id"
                            titleTextType="I18N"
                            valueText={data.transactionNumber}
                        />
                        {showEmailInfo && (
                            <>
                                <CustomData titleText="transfer.email.label" titleTextType="I18N" valueText={email} />
                                <CustomData
                                    titleText="transfer.emailText.label"
                                    titleTextType="I18N"
                                    valueText={emailText}
                                />
                            </>
                        )}
                        <CustomData
                            titleText="transfer.reference.label"
                            titleTextType="I18N"
                            valueText={reference}
                        />
                        <CustomData
                            titleText="transfer.reason.label"
                            titleTextType="I18N"
                            valueText={reason}
                        />
                    </div>
                    <ProgrammedBody />
                    <TransactionSign
                        isSmall
                        creationTime
                        hasVaucher
                        isDesktop={isDesktop}
                        noDate={isPending}
                        showMoreData={showMoreData}
                    />
                </div>
            </div>
        );
    }

    return (
        <div className="ticket__body newpayment">
            <div className="ticket-section section_trasfers">
                <div className="ticket-header-info">
                    <div className="beneficiary">
                        <div className="avatar-name">
                            <Avatar
                                user={{
                                    userFullName: beneficiary?.recipientName || "",
                                    defaultAvatarId: 0,
                                    email: beneficiary?.emailRecipient,
                                }}
                            />
                        </div>
                        <div className="user-info">
                            <div className="small">{i18n.get("echecks.beneficiary")}</div>
                            <div className="large">{`${beneficiary?.recipientName}`}</div>
                            <div className="small">{`${beneficiary?.recipientDocumentType} ${beneficiary?.recipientDocumentNumber}`}</div>
                        </div>
                    </div>
                </div>
                <div className="ticket-header-info">
                    {isProgramed ? (
                        <CustomData
                            dataClass="amount tag tag-info"
                            titleText="transfer.transferred"
                            titleTextType="I18N"
                            valueText={<FormattedAmount currency={amount.currency} quantity={amount.quantity} />}
                        />
                    ) : (
                        <CustomData
                            dataClass={`amount tag tag-${isPending ? "warning" : "echeq-character"}`}
                            titleText="transfer.transferred"
                            titleTextType="I18N"
                            valueText={<FormattedAmount currency={amount.currency} quantity={amount.quantity} />}
                        />
                    )}
                </div>
            </div>
            <div className="ticket__divider inside-ticket__body">
                <div className="ticket__notch ticket__notch--left"> </div>
                <div className="ticket__notch ticket__notch--right"> </div>
            </div>
            <div className="view-more-data-button">
                <Button
                    aria-expanded={showMoreData ? "true" : "false"}
                    className="more-button"
                    label={buttonLabel}
                    bsStyle="link"
                    onClick={handleSeeMoreData}
                    image={showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"}
                />
            </div>
            <div className={`view-more-data ${showMoreData ? "expand " : "collapse"}`}>
                <div className="aditional-data">
                    <h2>{i18n.get("", "Datos adicionales")}</h2>
                    <CustomData
                        titleText="transfer.transferKind.label"
                        titleTextType="I18N"
                        valueTextType="I18N"
                        valueText={`transfer.types.${transferKind}`}
                    />
                    <CustomData
                        titleText="transfer.concept.label"
                        titleTextType="I18N"
                        valueTextType="I18N"
                        valueText={`transfer.reasons.${reasonCode}`}
                    />
                    <CustomData
                        titleText="transfer.reference.label"
                        titleTextType="I18N"
                        valueText={reference}
                    />
                    <CustomData
                        titleText="transfer.reason.label"
                        titleTextType="I18N"
                        valueText={reason}
                    />
                    <CustomData
                        titleText="transfer.debitAccount.label"
                        titleTextType="I18N"
                        valueText={debitAccountLabel}
                    />
                    <CustomData titleText="transfer.sender.label" titleTextType="I18N" valueText={ownerName} />
                    <CustomData
                        titleText="transfer.creditAccount.label"
                        titleTextType="I18N"
                        valueText={beneficiaryAccountLabel}
                    />
                    <CustomData
                        titleText="transfer.creditAccountCbuNumber.label"
                        titleTextType="I18N"
                        valueText={creditCbu}
                    />
                    <CustomData
                        titleText="transfer.CUIT/CUIL/CDI"
                        titleTextType="I18N"
                        valueText={`${beneficiary?.recipientDocumentType} ${beneficiary?.recipientDocumentNumber}`}
                    />
                    <CustomData
                        titleText="transfer.bank.label"
                        titleTextType="I18N"
                        valueText={beneficiary?.localBank}
                    />
                    {showEmailInfo && (
                        <>
                            <CustomData titleText="transfer.email.label" titleTextType="I18N" valueText={email} />
                            <CustomData
                                titleText="transfer.emailText.label"
                                titleTextType="I18N"
                                valueText={emailText}
                            />
                        </>
                    )}
                </div>
                {isProgramed && <ProgrammedBody />}
                <TransactionSign
                    isSmall
                    creationTime
                    hasVaucher
                    isDesktop={isDesktop}
                    noDate={isPending}
                    showMoreData={showMoreData}
                />
            </div>
        </div>
    );
};

BackofficeTransactionPage.propTypes = {
    creditCbu: string,
    transferKind: string,
    reasonCode: string,
    reference: string,
    reason: string,
    amount: shape({
        quantity: string,
        currency: string,
    }),
    sendEmail: bool,
    email: string,
    emailText: string,
    beneficiary: shape({}),
    scheduler: shape({}),
    showMoreData: bool,
    isDesktop: bool,
    setShowMoreData: func,
};

BackofficeTransactionPage.defaultProps = {
    creditCbu: "",
    transferKind: "",
    reasonCode: "",
    reference: "",
    reason: "",
    amount: {
        quantity: "",
        currency: "",
    },
    sendEmail: false,
    email: "",
    emailText: "",
    beneficiary: null,
    scheduler: null,
    showMoreData: false,
    isDesktop: false,
    setShowMoreData: () => { },
};

export default BackofficeTransactionPage;
